module.exports = __webpack_public_path__ + "assets/img/fangan02.751e8382.png";